<div class="seen-unseen-wrap">
  <div (click)="onClick()" title="{{ seenStateTitle }}">
    <span
      class="seen-unseen-icon {{ seenState }}"
      [inlineSVG]="seenStateIcon"></span>
  </div>
</div>
